import {
  createRouter,
  createWebHashHistory,
} from 'vue-router'

const routes = [
  // 路由的默认路径
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/newHeard',
    name: 'newHeard',
    component: () => import('@/views/newHeard/newHeard.vue'),
    meta: {
      title: '头部',
      keepAlive: true
    },
    children: [{
        path: '/newHome',
        name: 'newHome',
        component: () => import('@/views/newHome/newHome.vue'),
        meta: {
          title: '首页'
        }
      }, {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/'),
        meta: {
          title: '委员会客厅',
          keepAlive: true
        },
        children: []
      },
      {
        path: '/addMsg',
        name: 'addMsg',
        component: () => import('@/views/home/children/addMsg/'),
        meta: {
          title: '我要留言'
        }
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('@/views/home/children/detail/'),
        meta: {
          title: '值班详情'
        }
      },
      {
        path: '/remoteNegotiation',
        name: 'remoteNegotiation',
        component: () => import('@/views/remoteNegotiation/'),
        meta: {
          title: '远程协商'
        }
      },
      {
        path: '/remoteNegotiation-detail',
        name: 'remoteNegotiation-detail',
        component: () => import('@/views/remoteNegotiation/detail'),
        meta: {
          title: '远程协商详情'
        }
      },
      {
        path: '/internetPolitics',
        name: 'internetPolitics',
        component: () => import('@/views/internetPolitics/'),
        meta: {
          title: '网络议政'
        }
      },
      {
        path: '/internetPolitics-detail',
        name: 'internetPolitics-detail',
        component: () => import('@/views/internetPolitics/detail'),
        meta: {
          title: '网络议政详情'
        }
      },
      // 社情民意信息线索征集-首页
      {
        path: '/GatheringPublicOpinion',
        name: 'GatheringPublicOpinion',
        component: () => import('@/views/GatheringPublicOpinion/chooesList.vue'),
        meta: {
          title: '社情民意信息线索征集'
        }
      },
      // 社情民意信息线索征集-编写
      {
        path: '/GatheringPublicOpinionIndex',
        name: 'GatheringPublicOpinionIndex',
        component: () => import('@/views/GatheringPublicOpinion/index.vue'),
        meta: {
          title: '社情民意信息线索征集'
        }
      },
      // 社情民意信息线索征集-查询
      {
        path: '/GatheringPublicOpinionList',
        name: 'GatheringPublicOpinionList',
        component: () => import('@/views/GatheringPublicOpinion/list.vue'),
        meta: {
          title: '社情民意信息线索征集'
        }
      },
      {
        path: '/CallForProposals',
        name: 'CallForProposals',
        component: () => import('@/views/CallForProposals/chooesList'),
        meta: {
          title: '提案线索交互'
        }
      },
      {
        path: '/CallForProposalsIndex',
        name: 'CallForProposalsIndex',
        component: () => import('@/views/CallForProposals/'),
        meta: {
          title: '提案线索交互'
        }
      },
      {
        path: '/CallForProposalsList',
        name: 'CallForProposalsList',
        component: () => import('@/views/CallForProposals/list'),
        meta: {
          title: '提案线索交互'
        }
      },
      {
        path: '/Collection',
        name: 'Collection',
        component: () => import('@/views/Collection/'),
        meta: {
          title: '文史资料库'
        }
      },
      {
        path: '/Collection-detail',
        name: 'Collection-detail',
        component: () => import('@/views/Collection/detail'),
        meta: {
          title: '文史资料库详情'
        }
      },
      {
        path: '/Collection-add',
        name: 'Collection-add',
        component: () => import('@/views/Collection/add'),
        meta: {
          title: '文史资料库新增'
        }
      },
      {
        path: '/historicalData',
        name: 'historicalData',
        component: () => import('@/views/historicalData/index'),
        meta: {
          title: '文史资料库'
        }
      },
      {
        path: '/committeeWorkstationDetails',
        name: 'committeeWorkstationDetails',
        component: () => import('@/views/committeeWorkstation/committeeWorkstationDetails/committeeWorkstationDetails'),
        meta: {
          title: '豫事来商量详情'
        }
      },
      {
        path: '/committeeWorkstationList',
        name: 'committeeWorkstationList',
        component: () => import('@/views/committeeWorkstation/committeeWorkstationList/committeeWorkstationList'),
        meta: {
          title: '豫事来商量列表'
        }
      },
      {
        path: '/committeeWorkstationAdd',
        name: 'committeeWorkstationAdd',
        component: () => import('@/views/committeeWorkstation/committeeWorkstationAdd/'),
        meta: {
          title: '豫事来商量新增'
        }
      },
      {
        path: '/committeeWorkstationSearch',
        name: 'committeeWorkstationSearch',
        component: () => import('@/views/committeeWorkstation/committeeWorkstationSearch/'),
        meta: {
          title: '豫事来商量搜索'
        }
      }
    ]
  },
]

// 创建路由对象
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) { //判断是否有标题
    document.title = to.meta.title
  }
  next() //执行进入路由，如果不写就不会进入目标页
})

export default router